import {
  payloadComputedProperty,
  SB,
  searchableComputedProperty,
} from '@play-co/replicant';
import { ProfileState } from '.';

export const profileProperties = {
  profileName: payloadComputedProperty(
    SB.string(),
    (state: ProfileState) => state.profile?.name || '',
  ),

  profilePhoto: payloadComputedProperty(
    SB.string(),
    (state: ProfileState) => state.profile?.photo || '',
  ),

  // public profile data
  hasPublicProfile: searchableComputedProperty(
    SB.boolean(),
    (state: ProfileState) => !!state.publicProfile,
  ),
  publicProfileName: payloadComputedProperty(
    SB.string(),
    (state: ProfileState) => state.publicProfile?.name || '',
  ),
  publicProfilePhoto: payloadComputedProperty(
    SB.string(),
    (state: ProfileState) => state.publicProfile?.photo || '',
  ),
};
